/* Vanilla copy of src/js/script.src.js converted from jQuery to native DOM APIs.
 * This file binds page-level behaviors without relying on jQuery.
 */
(function(){
    function ready(fn){
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else { fn(); }
    }
    function onLoad(fn){ window.addEventListener('load', fn); }

    function toggleClass(el, cls, force){ if(!el) return; el.classList.toggle(cls, force); }
    function closest(el, sel){ while(el && el.nodeType===1){ if (el.matches(sel)) return el; el = el.parentElement; } return null; }

    function handleResize(){ onResize(); }
    function handleScroll(){ fixedSidebar(); backToTopButton(); }

    function dataShowSubmenuHandler(evt){
        var activator = evt.target.closest('[data-show-submenu]');
        if (!activator) return;
        evt.preventDefault();
        var target = activator.getAttribute('data-show-submenu');
        var wrap = closest(activator, '.content-nav-activator');
        if (wrap) toggleClass(wrap, 'open');
        var tgt = document.querySelector(target);
        if (tgt) {
            if (tgt.classList.contains('d-none')) {
                tgt.classList.remove('d-none'); tgt.classList.add('d-sm-block');
            } else {
                tgt.classList.add('d-none'); tgt.classList.remove('d-sm-block');
            }
        }
    }

    function pageContentsDropdownHandler(){
        setTimeout(function(){
            var activated = document.getElementById('page-contents-dropdown');
            var wHeight = window.innerHeight || document.documentElement.clientHeight || 0;
            var eOffsetTop = 0, eHeight = 0;
            if (activated) {
                var rect = activated.getBoundingClientRect();
                eOffsetTop = rect.top + window.pageYOffset;
                eHeight = activated.offsetHeight;
            }
            var y = (eOffsetTop + wHeight + eHeight) + 20;
            try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch(e) { window.scrollTo(0, y); }
            // Re-run sidebar sizing when Bootstrap collapse shows/hides
            document.addEventListener('shown.bs.collapse', function(){ removeAffixedSidebar(); fixedSidebar(); }, { once: true });
            document.addEventListener('hidden.bs.collapse', function(){ removeAffixedSidebar(); fixedSidebar(); }, { once: true });
        }, 300);
    }

    function initTooltips(root){
        if (typeof bootstrap === 'undefined' || !bootstrap.Tooltip) return;
        var scope = root || document;
        (scope.querySelectorAll('[data-bs-toggle="tooltip"]').forEach || Array.prototype.forEach.call)(scope.querySelectorAll('[data-bs-toggle="tooltip"]'), function(el){
            try { if (!bootstrap.Tooltip.getInstance || !bootstrap.Tooltip.getInstance(el)) new bootstrap.Tooltip(el); } catch(e){}
        });
    }

    function initTablesorter(root){
        // No jQuery in vanilla build; skip unless a non-jQuery tablesorter is provided.
        return;
    }

    function initialOnlineCheck(){
        if (location.protocol === 'file:') {
            var sm = document.getElementById('social-media-block');
            if (sm && sm.parentNode) sm.parentNode.removeChild(sm);
        }
    }

    function initShareThis(){
        if (location.protocol !== 'file:' && document.getElementById('social-media-block')) {
            var switchTo5x=false;
            LazyLoad.js('https://ws.sharethis.com/button/buttons.js', function () {
                try { stLight.options({servicePopup:true, publisher: "e2b56dee-d9c9-4413-91a8-a4aa2a935849", doNotHash: false, doNotCopy: false, hashAddressBar: false}); } catch(e){}
            });
        }
    }

    onLoad(function(){
        initialOnlineCheck();
        onResize();
        fixedSidebar();
        window.addEventListener('resize', debounce(onResize, 50));
        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', function(){ fixedSidebar(); });

        // Delegated events
        document.addEventListener('click', function(evt){
            if (evt.target.closest('[data-show-submenu]')) dataShowSubmenuHandler(evt);
        });
        var dropdownActivator = document.getElementById('page-contents-dropdown-activator');
        if (dropdownActivator) dropdownActivator.addEventListener('click', pageContentsDropdownHandler);

        // Initialize for existing DOM
        initTablesorter();
        initTooltips();

        // Observe DOM mutations to initialize dynamically injected content
        if (window.MutationObserver) {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (m) {
                    if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
                        m.addedNodes.forEach(function (node) {
                            if (node.nodeType !== 1) return; // ELEMENT_NODE only
                            initTablesorter(node);
                            initTooltips(node);
                        });
                    }
                });
            });
            try { observer.observe(document.body, { childList: true, subtree: true }); } catch (e) { }
        }

        // ShareThis
        initShareThis();
    });
})();
